<template>
    <div class="favorite-grid-root mb-3">
        <FavoriteCard v-for="fav in data" :key="fav.id" :data="fav" />
    </div>
</template>

<script>
import FavoriteCard from './FavoriteCard';

export default {
    name: 'FavoriteGrid',
    components: { FavoriteCard },
    props: {
        data: {
            type: Array,
            default: () => [],
        },
    },
};
</script>

<style scoped>
.favorite-grid-root {
    display: grid;

    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: var(--grid-gap);
}

@media only screen and (max-width: 600px) {
    .favorite-grid-root {
        grid-template-columns: 1fr;
    }
}
</style>
